export default __webpack_public_path__ + "img_outlaw.93fb7d.svg";